import type { PopoverProps } from '@mui/material';
import { Popover, popoverClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CollapsedSubMenu = styled(({ ...props }: PopoverProps) => <Popover {...props} />)(
  ({ theme }) => ({
    [`& .${popoverClasses.paper}`]: {
      marginLeft: '8px',
      backgroundColor: theme.mainColors.titan100,
      fontFamily: 'Telka, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      padding: '4px',
      gap: '2px',
      borderRadius: '8px',
      boxShadow:
        '0px 29px 11px 0px rgba(22, 22, 20, 0.02), 0px 16px 10px 0px rgba(22, 22, 20, 0.06), 0px 7px 7px 0px rgba(22, 22, 20, 0.10), 0px 2px 4px 0px rgba(22, 22, 20, 0.11);',
    },
  }),
);
